import script from "./release.vue?vue&type=script&setup=true&lang=ts"
export * from "./release.vue?vue&type=script&setup=true&lang=ts"

import "./release.vue?vue&type=style&index=0&id=8db69b22&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8db69b22"]])

export default __exports__